// extracted by mini-css-extract-plugin
export default {"scrollButton":"Scroll_scrollButton__hFM2u","showButton":"Scroll_showButton__tQ4n1","arrow":"Scroll_arrow__ekj5P"};